import React, { useState, useEffect, useRef } from "react";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import Navigation from "./components/navigation";
import Footer from "./components/footer";
import Home from "./components/Home";
import RegistrationForm from "./components/Form";
import VerifyCertificate from "./components/verification";
import LoginPage from "./views/pages/authentication/Login";
import CenterLoginPage from "./views/pages/authentication/CenterLogin";
import Dashboard from "./views/pages/Dashboard";
import CenterDashboard from "./views/pages/CenterDashboard";
import SetPassword from "./views/pages/setPassword/SetPassword";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import { Contact } from "./components/contact";
import { createTheme, ThemeProvider } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import useAuth from "./hooks/useAuth";
import { logoutUser } from "./redux/user/userSlice";

import { toast } from 'react-toastify';

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});
const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
    background: {
      default: '#f5f5f5',
    },
  },
});

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  const { user } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const { request } = useAuth();
  const sessionExpiredRef = useRef(false);

  const [isLoggedIn, setIsLoggedIn] = useState(true);
  const location = useLocation();

  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);


  // Check if user exists in the database
  useEffect(() => {
    checkUser();

    // eslint-disable-next-line
  }, []);

 

  const checkUser = async () => {
    if (user?.userId) {
      try {
        const isCenterUser = user?.role === "CENTER";
        const endpoint = isCenterUser ? "/center/profile" : "/user";
        const config = isCenterUser ? {} : { params: { userId: user?.userId } };

        const response = await request.get(endpoint, config);
        if (!response?.data) {
          dispatch(logoutUser());
        }
      } catch (error) {
        const statusCode = error?.response?.status || 500;
        const message = error?.response?.data?.message || "An error occurred";
        if (statusCode === 401 && message === "Invalid or expired token") {
          dispatch(logoutUser());
          if (!sessionExpiredRef.current) {
            sessionExpiredRef.current = true;
            toast.error("Your session has expired. Please sign in again to continue.");
          }
        } else if (statusCode === 401 || statusCode === 404) {
          dispatch(logoutUser());
        }
      }
    }
  };

  console.log("user>>>", isLoggedIn)

  const hideNavAndFooter =
    location.pathname === "/login" ||
    location.pathname === "/dashboard" ||
    location.pathname === "/center-login" ||
    location.pathname === "/center-dashboard" ||
    location.pathname.startsWith("/set-password");

  return (
    <ThemeProvider theme={theme}>
      <ToastContainer />
      {!hideNavAndFooter && <Navigation />}
      <Routes>
        {/* Admin routes */}
        <Route path="/login" element={!user ? <LoginPage /> : <Navigate to="/dashboard" />} />
        <Route
          path="/dashboard"
          element={user && user?.role !== "CENTER" ? <Dashboard /> : <Navigate to="/login" />}
        />

        {/* Center user routes */}
        <Route path="/center-login" element={user?.role === "CENTER" ? <Navigate to="/center-dashboard" /> : <CenterLoginPage />} />
        <Route
          path="/center-dashboard"
          element={user?.role === "CENTER" ? <CenterDashboard /> : <Navigate to="/center-login" />}
        />
        <Route path="/set-password/:token" element={<SetPassword />} />

        {/* Public routes */}
        <Route path="/" element={<Home data={landingPageData} />} />
        <Route path="/contact" element={<Contact data={landingPageData.Contact} />} />
        <Route path="/form" element={<RegistrationForm />} />
        <Route path="/verify" element={<VerifyCertificate />} />
      </Routes>

      {!hideNavAndFooter && <Footer />}
    </ThemeProvider>
  );
};

export default App;
